import * as React from 'react';
import { SVGProps } from 'react';

const IconWellOpenSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 2v3.764L4.882 12 8 18.236V22h2v-4.236L7.118 12 10 6.236V2H8ZM16 2v3.764L19.118 12 16 18.236V22h-2v-4.236L16.882 12 14 6.236V2h2Z" />
  </svg>
);
export default IconWellOpenSizeM;
